export default {"src":"/_next/static/media/cargill.cbbd9eee.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};